import Vue from "vue";
import Axios from "axios";
import router from "@/router";
import store from "@/store";
import {
  displayErrors,
  backendAddress
} from "@/utils/helpers";

Axios.defaults.baseURL = backendAddress("/api");

Axios.interceptors.request.use(config => {
  store.dispatch("loading");
  if (sessionStorage.getItem("token")) {
    config.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("token");
  }
  config.withCredentials = true;
  return config;
});

Axios.interceptors.response.use(
  response => {
    store.dispatch("loaded");
    return response;
  },
  error => {
    store.dispatch("loaded");
    if (error.response) {
      if (error.response.status == 400) {
        displayErrors(error.response.data);
      }
      if (error.response.status == 401) {
        router.push({
          path: "/login"
        });
      }
      if (error.response.status == 403) {
        router.push({
          path: "/forbidden"
        });
      }
      if (error.response.status == 404) {
        router.push({
          path: "/notfound"
        });
      }
      if (error.response.status == 410) {
        displayErrors(error.response.data)
        displayErrors('Za chwilę nastąpi wylogowanie...')
        setTimeout(() => {
          store.dispatch("logout")
        }, 3000)
      }
    } else {
      displayErrors("Wystąpił błąd");
    }
    return Promise.reject(error);
  }
);

Vue.$http = Axios;

Object.defineProperty(Vue.prototype, "$http", {
  get() {
    return Axios;
  }
});

export default {
  get(endpoint) {
    return Vue.$http.get(`${endpoint}`);
  },
  getById(endpoint, id) {
    return Vue.$http.get(`${endpoint}/${id}`);
  },
  put(endpoint, id, data) {
    return Vue.$http.put(`${endpoint}/${id}`, data);
  },
  post(endpoint, data) {
    return Vue.$http.post(`${endpoint}`, data);
  },
  delete(endpoint, id) {
    return Vue.$http.delete(`${endpoint}/${id}`);
  },
  getFile(endpoint, id) {
    return Vue.$http.get(`${endpoint}/${id}`, {
      responseType: "blob"
    });
  },
  postFile(endpoint, type, id, data) {
    return Vue.$http.post(`${endpoint}/${type}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
  }
};
